import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NativeDateAdapter, MatStepperModule } from '@angular/material';

import {
  MatButtonModule, MatCheckboxModule, MatListModule, MatCardModule, MatIconModule, MatRadioModule,
  MatTooltipModule, MatTabsModule, MatSlideToggleModule, MatSelectModule,
  MatDialogModule, MatDatepickerModule, MatNativeDateModule,
  MatInputModule,MatSliderModule,
  MatGridListModule,MatExpansionModule, MatMenuModule, MatLineModule, MatTableModule, MatProgressSpinnerModule, DateAdapter
} from '@angular/material';
import { CdkTableModule } from '@angular/cdk/table';

export class MyDateAdapter extends NativeDateAdapter {

    getFirstDayOfWeek(): number {
      return 1;
    }

  }

@NgModule({
  imports: [MatButtonModule, MatCheckboxModule, MatListModule, MatCardModule, MatIconModule, MatRadioModule,
    MatTooltipModule, MatTabsModule, MatSlideToggleModule, MatSelectModule,
    MatDialogModule, MatDatepickerModule, MatNativeDateModule,MatSliderModule,
    MatInputModule,MatExpansionModule,MatStepperModule,
    MatGridListModule, MatMenuModule, MatLineModule, CdkTableModule, MatTableModule, MatProgressSpinnerModule],

  exports: [MatButtonModule, MatCheckboxModule, MatListModule, MatCardModule, MatIconModule, MatRadioModule,
    MatTooltipModule, MatTabsModule, MatSlideToggleModule, MatSelectModule, MatDatepickerModule,
    MatDialogModule, MatNativeDateModule,MatSliderModule,
    MatInputModule,MatExpansionModule,MatStepperModule,
    MatGridListModule, MatMenuModule, MatLineModule, CdkTableModule, MatTableModule, MatProgressSpinnerModule],

    providers: [{provide: DateAdapter, useClass: MyDateAdapter }]

})

export class MaterialModule {

    constructor(protected dateAdapter: DateAdapter<Date>)
    {
      this.dateAdapter.setLocale('fr');
    }

    getFirstDayOfWeek(): number {
      return 1;
    }

  }





// WEBPACK FOOTER //
// ./src/app/shared/material-design/mat-modules.ts